var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.41918 -2.11491e-07C0.528272 -1.33606e-07 0.0771353 1.07714 0.707098 1.70711L4.29289 5.29291C4.68342 5.68344 5.31658 5.68344 5.70711 5.29291L9.2929 1.7071C9.92287 1.07714 9.47556 -9.15802e-07 8.58465 -8.37917e-07C4.57197 -4.87117e-07 4.93474 -5.18832e-07 1.41918 -2.11491e-07Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.38e86bb67649afef8ad9641a45902195.svg";
export { ForwardRef as ReactComponent };